// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-history-list-action-column {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: hidden;
}
.fi-history-list-action-column .super-admin-icon {
  color: var(--fi-color-red);
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./Source/app/history/history-list/history-list-action-column/history-list-action-column.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAAI;EACI,0BAAA;EACA,gBAAA;AAER","sourcesContent":[".fi-history-list-action-column {\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow-x: hidden;\r\n    .super-admin-icon {\r\n        color: var(--fi-color-red);\r\n        margin-left: 8px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
